const viewGoalcard = (state = { isProcessing: true }, action) => {
  switch (action.type) {
    case 'GET_GOALCARD':
      return {
        ...state,
        isProcessing: true,
        isFromAffiliate: false,
      };
    case 'GET_GOALCARD_AFFILIATE':
      return {
        ...state,
        isProcessing: true,
        isFromAffiliate: true,
      };
    case 'GET_GOALCARD_SUCCESS':
      return {
        ...state,
        goalcard: action.data,
        isProcessing: false,
      };
    case 'GET_GOALCARD_FAIL':
      return {
        ...state,
        error: action.error,
        isProcessing: false,
        isFromAffiliate: false,
      };
    default:
      return state;
  }
};

export default viewGoalcard;
